import type { Theme } from "./theme";

export function LogoMark({ theme, size = 22 }: { theme: Theme; size?: number }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect x="1" y="1" width="22" height="22" rx="5" fill={theme.accent} />
      <path
        d="M7 17V7h5a3.5 3.5 0 0 1 1.2 6.8L16 17h-2.6l-2.6-3.6H9.2V17H7zm2.2-5.2h2.7a1.6 1.6 0 0 0 0-3.2H9.2v3.2z"
        fill={theme.onAccent}
      />
    </svg>
  );
}

export function ArrowRightIcon({ size = 14 }: { size?: number }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    >
      <path d="M3 7h8m-3-3l3 3-3 3" />
    </svg>
  );
}

export function CheckIcon({ size = 10, stroke }: { size?: number; stroke?: string }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width={size}
      height={size}
      viewBox="0 0 10 10"
      fill="none"
      stroke={stroke || "currentColor"}
      strokeWidth="1.8"
      strokeLinecap="round"
    >
      <path d="M2 5l2 2 4-4" />
    </svg>
  );
}

export function SuccessCheckIcon({ size = 20 }: { size?: number }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    >
      <path d="M5 10l3 3 7-7" />
    </svg>
  );
}

export function PersonIcon({ color }: { color: string }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
    >
      <circle cx="6" cy="4" r="2" />
      <path d="M2 11c.5-2 2.2-3 4-3s3.5 1 4 3" />
    </svg>
  );
}

export function ResourceIcon({ i }: { i: number }) {
  const icons = [
    <path d="M4 3h8v10H4zM6 6h4M6 8h4M6 10h3" key="a" />,
    <path d="M3 4h10M3 8h10M3 12h6" key="b" />,
    <path d="M3 3h10v10H3zM6 6l2 2 4-4" key="c" />,
    <path d="M4 11V5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6M4 11l2-2 2 2 2-2 2 2" key="d" />,
    <path d="M3 3h4v10H3zM9 3h4v10H9z" key="e" />,
  ];
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {icons[i] || icons[0]}
    </svg>
  );
}
